/**
 * Филтр опциялари таржимаси (БДдаги каноник қийматлар).
 */
export default {
  'Продажа': 'Сотилади',
  'Аренда': 'Ижара',
  'Аренда долгосрочная': 'Узоқ муддатли ижара',
  'Обмен': 'Алмашинув',
  'Квартиры': 'Квартиралар',
  'Дома': 'Уйлар',
  'Земля': 'Ер',
  'Гаражи / стоянки': 'Гаражлар / тўхташ жойлари',
  'Коммерческие помещения': 'Тижорат жойлари',
  'От застройщика': 'Қурувчидан',
}
